import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Spinner } from '@/components/atoms';
import { LayoutCentred } from '@/components/templates';
import { useMeQuery } from '@/hooks';

// Modified to be used as an element in a Route component
const AuthenticatedRoute = ({ role, component }) => {
    const location = useLocation();
    const { data, error, loading } = useMeQuery();

    if (loading)
        return (
            <LayoutCentred>
                <Spinner />
            </LayoutCentred>
        );
    if (error) return <h1>{error.message}</h1>;

    const isAuthenticated = data && data.me;
    if (isAuthenticated) {
        const isLocked = data.me.locked;
        if (isLocked) {
            return <Navigate replace to="/locked" />;
        } else {
            const hasRole = role ? data.me.roles.find(({ type }) => type.toLowerCase() === role.toLowerCase()) : true;
            if (hasRole) {
                // Create the component directly without any path props
                const Component = component;
                return <Component />;
            } else {
                return <Navigate replace to="/" />;
            }
        }
    } else {
        // Use state to remember where we were going
        return <Navigate replace to="/login" state={{ from: location.pathname }} />;
    }
};

export { AuthenticatedRoute };
